import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "triggerConfigForm",
    "triggerTypeButtonGroup",
    "triggerTypeInput",
    "triggerTypeDisplay",
    "actionConfigForm",
    "actionTypeButtonGroup",
    "actionTypeInput"
  ]

  static values = {
    hasTrigger: Boolean,
    hasAction: Boolean,
    actionId: Number,
  }

  connect() {
    window.addEventListener("openTriggerSidebar", this.openTriggerConfigFromCard.bind(this))
    window.addEventListener("openActionSidebar", this.openActionConfigFromCard.bind(this))
    window.addEventListener("openNewActionSidebar", this.openNewActionSidebar.bind(this))

    if (!this.hasTriggerValue) {
      this.triggerTypeSidebar()
    } else if (!this.hasActionValue) {
      this.actionTypeSidebar()
    } else {
      this.element.style.display = "none" // Hide the whole sidebar
    }
  }

  triggerTypeSidebar() {
    //Hide the trigger config form
    this.triggerConfigFormTarget.hidden = true
    this.triggerTypeInputTarget.value = null
    this.triggerTypeDisplayTarget.textContent = null

    //Show the trigger type buttons
    this.triggerTypeButtonGroupTarget.style.display = "contents"

    //Hide the action type buttons
    this.actionTypeButtonGroupTarget.style.display = "none"

    //Hide the action config form
    this.actionConfigFormTarget.hidden = true
    this.actionTypeInputTarget.value = null
  }

  triggerConfigSidebar(event) {
    const type = event.params.triggerType

    //Show the trigger config form
    this.triggerConfigFormTarget.hidden = false
    this.triggerTypeInputTarget.value = type
    this.triggerTypeDisplayTarget.textContent = this.triggerTypeText(type)

    //Hide the trigger type buttons
    this.triggerTypeButtonGroupTarget.style.display = "none"

    //Hide the action type buttons
    this.actionTypeButtonGroupTarget.style.display = "none"

    //Hide the action config form
    this.actionConfigFormTarget.hidden = true
    this.actionTypeInputTarget.value = null
  }

  actionTypeSidebar() {
    //Hide the trigger config form
    this.triggerConfigFormTarget.hidden = true
    this.triggerTypeInputTarget.value = null
    this.triggerTypeDisplayTarget.textContent = null

    //Hide the trigger type buttons
    this.triggerTypeButtonGroupTarget.style.display = "none"

    //Show the action type buttons
    this.actionTypeButtonGroupTarget.style.display = "contents"

    //Hide the action config form
    this.actionConfigFormTarget.hidden = true
    this.actionTypeInputTarget.value = null
  }

  actionConfigSidebar(event) {
    const type = event.params.actionType

    //Hide the trigger config form
    this.triggerConfigFormTarget.hidden = true
    this.triggerTypeInputTarget.value = null
    this.triggerTypeDisplayTarget.textContent = null

    //Hide the trigger type buttons
    this.triggerTypeButtonGroupTarget.style.display = "none"

    //Hide the action type buttons
    this.actionTypeButtonGroupTarget.style.display = "none"

    //Show the action config form
    this.actionConfigFormTarget.hidden = false
    this.actionTypeInputTarget.value = type
  }

  showSidebar() {
    this.element.style.display = "flex" 
  }

  openTriggerConfigFromCard(event) {
    const type = event.detail.triggerType
    if (!type) return
  
    this.showSidebar()
    this.triggerConfigSidebar({ params: { triggerType: type } })
  }

  openActionConfigFromCard(event) {
    const type = event.detail.actionType
    const id = event.detail.actionId // You’ll pass this from the card
    if (!type || !id) return

    this.actionIdValue = id
    this.showSidebar()
    this.actionConfigSidebar({ params: { actionType: type } })

    // Populate the form fields
    const idInput = this.element.querySelector('input[name="workflow_action[id]"]')
    if (idInput) idInput.value = id

    const typeInput = this.element.querySelector('input[name="workflow_action[action_type]"]')
    if (typeInput) typeInput.value = type

    // These depend on your action_data format
    const flagSelect = this.element.querySelector('select[name="workflow_action[action_data][flag_type_id]"]')
    if (flagSelect) {
      const flag = event.detail.flagTypeId
      if (flag) flagSelect.value = flag
    }

    const descriptionInput = this.element.querySelector('textarea[name="workflow_action[action_data][description]"]')
    if (descriptionInput) {
      descriptionInput.value = event.detail.description || ""
    }
  }

  openNewActionSidebar() {
    this.actionIdValue = null
  
    const idInput = this.element.querySelector('input[name="workflow_action[id]"]')
    if (idInput) idInput.value = ""
  
    const typeInput = this.element.querySelector('input[name="workflow_action[action_type]"]')
    if (typeInput) typeInput.value = ""
  
    this.showSidebar()
    this.actionTypeSidebar()
  }

  triggerTypeText(str) {
    if (str == "create_record") {
      return "When a record is created..."
    } else if (str == "update_record") {
      return "When a record is updated..."
    } else { return nil }
  }
}

